import {
  refreshFormResetButton,
  updateFormFilterFacets
} from "../Shared/Utilities/filterFacets";

const initializeFactsAndAdviceFinder = (form: HTMLFormElement) => {
  const filterDropdowns = Array.from(
    form.querySelectorAll<HTMLElement>("[data-filter-dropdown]")
  );

  filterDropdowns.map(filterDropdown => {
    const select = filterDropdown.querySelector("select");

    if (select) {
      select.addEventListener("change", async _ => {
        // Submit the form whenever a filter is updated
        form.requestSubmit();
      });
    }
  });

  htmx.on(form, "htmx:afterOnLoad", _ => {
    updateFormFilterFacets(form);

    refreshFormResetButton(form);
  });
};

document
  .querySelectorAll<HTMLFormElement>("[data-facts-and-advice-finder]")
  .forEach(element => initializeFactsAndAdviceFinder(element));
